export default {
    'diagram3b4-2': {
        'diagram-task': 'Inductive',
        'diagram-peak': 'The idea of mind taping to preserve personality is almost certainly wrong',
        'diagram-hint': 'Why?',
        'diagram-answers': {
            '1': 'Brains are not like computers',
            '2': 'Brains are uniquely configured',
            '3': 'Don’t have a tape that could record the uniqueness',
            '4': 'Difficult to construct a tape for a “mind taping” session',
            '5': 'Can’t find hardware on which to read the recording',
            '6': 'The mind tape would not be compatible with another brain’s hardware',
            '7': 'Can’t insert the results into another brain',
        },
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b4/diagram2/i18n/en.js